module.exports = __webpack_public_path__ + "img/Edit.d443ec73.svg";